import { AfterViewInit, Component } from "@angular/core";
import { Observable } from "rxjs";
import { SchoolsService } from "src/app/services";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements AfterViewInit {
  public schools: Observable<any[]>;
  constructor(private readonly schoolsService: SchoolsService) {
  }

  ngAfterViewInit(): void {
    this.schools = this.schoolsService.getAll();
    this.schools.subscribe();
  }
}
